import { findFormControl } from "./helpers";

const HINT_FIELD_CLASS = "o-form-control__hint";
const ERROR_MODIFIER_CLASS = "o-form-control--error";

export function setErrorInHint<T extends HTMLElement>(
    element: T,
    error: string
) {
    const formControl = findFormControl(element);
    if (!formControl) return;
    const hint = formControl.querySelector(
        `.${HINT_FIELD_CLASS}`
    ) as HTMLParagraphElement;

    if (!error) {
        formControl.classList.remove(ERROR_MODIFIER_CLASS);
    } else {
        formControl.classList.add(ERROR_MODIFIER_CLASS);
    }

    hint.innerText = error;
}

export function addFileToHTML<T extends HTMLElement>(box: T, file: File) {
    const fileTemplateNode = box.querySelector("template")!;
    const fileTemplate = document.importNode(fileTemplateNode, true);
    const filesContainer = box.querySelector(".c-file-box__files")!;
    const fileDiv = fileTemplate.content.querySelector("div")!;
    const fileSpan = fileDiv.querySelector("span")!;
    const newSpan = document.createElement("span");
    const fileName = document.createTextNode(`${file.name}`);
    newSpan.appendChild(fileName);
    fileDiv.replaceChild(newSpan, fileSpan);
    filesContainer.appendChild(fileDiv);

    return fileDiv;
}

type FileStatus = "success" | "loading" | "upload-error" | "delete-error";

export function updateFileStatus<T extends HTMLElement>(
    fileElement: T,
    status: FileStatus,
    id = ""
) {
    const loadingClass = "is-loading";
    const addClass = (className) => fileElement.classList.add(className);
    const removeClass = (className) => fileElement.classList.remove(className);

    switch (status) {
        case "success":
            removeClass(loadingClass);
            if (id) {
                fileElement.setAttribute("data-id", id);
            }
            break;
        case "loading":
            addClass(loadingClass);
            break;
        case "upload-error":
            removeClass(loadingClass);
            addClass("is-upload-error");
            break;
        case "delete-error":
            removeClass(loadingClass);
            addClass("is-delete-error");
            break;
    }
}